import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  ActivityApiModel,
  ReassignDatesApiModel,
  ActivityRequestApiModel,
  PaginationActivityResponseApiModel,
  AdditionalActivityItemsApiModel
} from '@app/api/api-models/activities';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class ActivitiesService {
  public apiUrl = 'activities';

  constructor(private readonly http: HttpClientService) {}

  public getList(params: ActivityRequestApiModel): Observable<PaginationActivityResponseApiModel> {
    return this.http.get<PaginationActivityResponseApiModel>(`${this.apiUrl}/get-list`, { params: params }).pipe(
      map((response) => {
        response.Items = response.Items.map((x) => new ActivityApiModel().deserialize(x));
        return response;
      })
    );
  }

  public add(model: ActivityApiModel, isForMultipleTrainee = false): Observable<ActivityApiModel> {
    if (isForMultipleTrainee) {
      return this.http
        .post<ActivityApiModel>(`${this.apiUrl}/add-for-multiple-trainee`, model)
        .pipe(map((x) => new ActivityApiModel().deserialize(x)));
    }
    return this.http
      .post<ActivityApiModel>(`${this.apiUrl}/add`, model)
      .pipe(map((x) => new ActivityApiModel().deserialize(x)));
  }

  public update(model: ActivityApiModel, isForMultipleTrainee = false): Observable<ActivityApiModel> {
    if (isForMultipleTrainee) {
      return this.http
        .put<ActivityApiModel>(`${this.apiUrl}/update-for-multiple-trainee`, model)
        .pipe(map((x) => new ActivityApiModel().deserialize(x)));
    }
    return this.http
      .put<ActivityApiModel>(`${this.apiUrl}/update`, model)
      .pipe(map((x) => new ActivityApiModel().deserialize(x)));
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}`);
  }

  public reassignDates(model: ReassignDatesApiModel): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/reassign-dates`, model);
  }

  public getById(id: number): Observable<ActivityApiModel> {
    return this.http
      .get<ActivityApiModel>(`${this.apiUrl}/get/${id}`)
      .pipe(map((x) => new ActivityApiModel().deserialize(x)));
  }

  public getAdditionalItems(
    formInstanceId: number,
    activityTypeId: string,
    skillId?: number,
    performanceCategoryId?: number,
    callTypeId?: number
  ): Observable<AdditionalActivityItemsApiModel> {
    const params: any = { formInstanceId, activityTypeId };
    if (skillId != null) params.skillId = skillId;
    if (performanceCategoryId != null) params.performanceCategoryId = performanceCategoryId;
    if (callTypeId != null) params.callTypeId = callTypeId;
    return this.http.get<AdditionalActivityItemsApiModel>(`${this.apiUrl}/additional-items`, { params });
  }
}
